teardown =
	teardown: ->

Ractive::unset = (keypath) ->
	lastDot = keypath.lastIndexOf '.'
	parent = keypath.substr 0, lastDot
	property = keypath.substring lastDot + 1

	@set keypath
	delete @get(parent)[property]
	@update keypath

Ractive::getNodeKeypath = (node) ->
	return false unless _.has node, '_ractive.binding.keypath.str'
	node._ractive.binding.keypath.str

helpers = Ractive.defaults.data

helpers.price = (price) ->
	return if _.isUndefined price
	price = unless _.isString price then price.toString() else price
	price.replace /(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '

helpers.uppercase = (text) ->
	return unless text
	text = if typeof text isnt 'string' then text.toString() else text
	text.toUpperCase()

Ractive.decorators.setTrue = (el) ->
	$el = $ el
	$el.prop 'checked', true
	@updateModel()

	return teardown

Ractive.decorators.set = (el, keypath) ->
	$el = $ el
	$el.val @get keypath
	@updateModel()

	@observe keypath, (newValue) ->
		$el.val newValue
		@updateModel()

	return teardown

Ractive.decorators.selectric = require './decorators/selectric.coffee'
Ractive.decorators.numbers = require './decorators/numbers.coffee'
Ractive.decorators.slider = require './decorators/slider.coffee'
Ractive.decorators.cloner = require './decorators/cloner.coffee'



/** WEBPACK FOOTER **
 ** ./assets/coffee/ractive.coffee
 **/